import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'  //首页
import teacher from '@/pages/other/teacher'  //老师
import privacy from '@/pages/other/privacy'  //隐私政策
import sitemap from '@/pages/other/sitemap'  //网站地图
import careers from '@/pages/careers'  //立刻申请
import appointment from '@/pages/appointment/appointment' //家长预约
import joinUs from '@/pages/join/joinUs' // 加入凯斯
import story from '@/pages/about/story' //关于凯斯 - 半个世纪故事
import china from '@/pages/about/china' //关于凯斯 - 爱在中国
import belief from '@/pages/about/belief' //关于凯斯  凯斯信念
import chooseUs from '@/pages/choose/chooseUs' //选择凯斯 - 核心优势
import course from '@/pages/choose/course' //选择凯斯 - 专业课程
import kindergarten from '@/pages/kindergarten/index' //园所选择

//选择凯斯 - QA体系
//选择凯斯 - 透明管理
//选择凯斯 - 食品健康

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: 'index'
      }
    },
    {
      path: '/other/teacher',//老师
      name: 'teacher',
      component: teacher,
      meta: {
        title: 'teacher'
      }
    },
    {
      path: '/other/privacy',//隐私政策
      name: 'privacy',
      component: privacy,
      meta: {
        title: 'privacy'
      }
    },
    {
      path: '/other/sitemap',//网站地图
      name: 'sitemap',
      component: sitemap,
      meta: {
        title: 'sitemap'
      }
    },
    {
      path: '/appointment',
      name:'appointment',
      component: appointment,
      meta: {
        title: 'appointment'
      }
    },
    {
        path: '/join', //加入凯斯 - 凯斯大家庭
        name:'join',
        redirect:'/join/work',
        component: joinUs,
        meta: {
          title: 'Join Us'
        },
        // children:[{
        //     path:'/join/family',name:'family',component:joinUs, meta: {title: 'Join Us'},
        //     path:'/join/work',name:'work',component:joinUs, meta: {title: 'Join Us'},
        //     path:'/join/apply',name:'apply',component:joinUs, meta: {title: 'Join Us'},
        // }]
    },
    {
        path: '/join/work', // 加入凯斯 - 工作和生活
        name:'work',
        component: joinUs,
        meta: {
          title: 'Join Us'
        }
    },
    {
        path: '/careers', //加入凯斯 - 立即申请
        name:'careers',
        component: careers,
        meta: {
          title: 'careers'
        }
    }, 
    {
      path: '/join/letter', //加入凯斯 - 给家长的一封信
      name:'letter',
      component: joinUs,
      meta: {
        title: 'Join Us'
      }
  }, 
    {
        path: '/about', //关于凯斯 - 半个世纪的故事
        name:'about',
        redirect:'/about/story',
        component: story,
        meta: {
          title: 'About Us'
        },
        // children:[{
        //     path:'/about/story',name:'story',component:story, meta: {title: 'About Us'},
        //     path:'/about/china',name:'china',component:china, meta: {title: 'About Us'},
        //     path:'/about/belief',name:'belief',component:belief, meta: {title: 'About Us'},
        // }]
    },
    {
        path: '/about/story', //关于凯斯 - 半个世纪的故事
        name:'story',
        component: story,
        meta: {
          title: 'About Us'
        }
    },
    {
        path: '/about/china', //关于凯斯 - 爱在中国
        name:'china',
        component: china,
        meta: {
          title: 'About Us'
        }
    },
    {
        path: '/about/belief', //关于凯斯 - 凯斯信念
        name:'belief',
        component: belief,
        meta: {
          title: 'About Us'
        }
    },
    {
        path: '/choose', //选择凯斯
        name:'choose',
        redirect:'/choose/advantage',
        component: chooseUs,
        meta: {
          title: 'Choose Us'
        }
    }, 
    {
        path: '/choose/advantage', //选择凯斯 - 核心优势
        name:'advantage',
        component: chooseUs,
        meta: {
          title: 'Choose Us'
        },
    },
    {
        path: '/choose/course', //选择凯斯 - 专业课程
        name:'course',
        component: chooseUs,
        meta: {
          title: 'Choose Us'
        },
    }, 
    {
        path: '/choose/qa', //选择凯斯 - QA体系
        name:'qa',
        component: chooseUs,
        meta: {
          title: 'Choose Us'
        },
    }, 
    {
        path: '/choose/manage', //选择凯斯 - 透明管理
        name:'manage',
        component: chooseUs,
        meta: {
          title: 'Choose Us'
        },
    }, 
    {
        path: '/choose/foodhealth', //选择凯斯 - 食品健康
        name:'foodhealth',
        component: chooseUs,
        meta: {
          title: 'Choose Us'
        },
    },
    {
      path: '/choose/parents', //选择凯斯 - 家长说
      name:'parents',
      component: chooseUs,
      meta: {
        title: 'Choose Us'
      },
  },
  {
      path: '/kindergarten/index', //选择凯斯 - 园区分布
      name:'kindergarten',
      component: kindergarten,
      meta: {
        title: 'Choose Us'
      },
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js